const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfWonders extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfWonders,
            "Each civilization scores culture for each wonders:\n" +
            "5 for age A\n" +
            "4 for age I\n" +
            "3 for age II\n" +
            "2 for age III",
            {}
        )
    }
}

module.exports = ImpactOfWonders;